export const UPDATE_STUDENT1_TAB = 'UPDATE_STUDENT1_TAB';
export const UPDATE_STUDENT2_TAB = 'UPDATE_STUDENT2_TAB';
export const UPDATE_NAVIGATION_CONFIG_TAB = 'UPDATE_NAVIGATION_CONFIG_TAB';
